// ErrorContextProvider.js
import React, { createContext, useContext, useState, useMemo } from 'react';

const ErrorContext = createContext(null);

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const showError = (message, type = 'error') => {
    setError({ message, type });
    setIsVisible(true);
  };

  const hideError = () => {
    setIsVisible(false);
    // Clear error after animation completes
    setTimeout(() => setError(null), 300);
  };

  const showSuccess = (message) => {
    showError(message, 'success');
  };

  const showWarning = (message) => {
    showError(message, 'warning');
  };

  const showInfo = (message) => {
    showError(message, 'info');
  };

  const value = useMemo(() => ({
    error,
    isVisible,
    showError,
    showSuccess,
    showWarning,
    showInfo,
    hideError
  }), [error, isVisible]);

  return (
    <ErrorContext.Provider value={value}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (context === undefined) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};

export default ErrorProvider;